<template>
    <div id="app">
        <v-app id="inspire">
            <v-main class="notransition">
                <snackbar ref="snackbar"></snackbar>
                <v-container class="page-container" fluid>
                    <header id="main-header">
                        <div class="logo-container">
                            <a href="https://medplay.it/">
                                <img src="./assets/logo.png" />
                            </a>
                        </div>
                    </header>
                    <v-row class="mt-8">
                        <v-col class="main-container">
                            <router-view :key="$route.path"></router-view>
                        </v-col>
                    </v-row>
                </v-container>
            </v-main>
        </v-app>
    </div>
</template>

<script>

import Snackbar from "./components/Snackbar";

export default {

    components: {Snackbar},

    mounted() {
        this.$root.$snackbar = this.$refs.snackbar;

        this.$root.showError = function(message, error) {
            this.$root.$snackbar.show(message, 'red');
            console.log(error);
        }
    }
}
</script>

<style>
    @import './assets/style/style.css';
</style>
